import { createFileRoute } from '@tanstack/react-router';
import { Container, Stack } from '@mantine/core';
import { ProtectedComponent } from '@/features/auth/components/ProtectedComponent';
import { FallbackType, UserRole } from '@/features/auth/domain/auth.types';
import { PageHeader } from '@/shared/components/ui/PageHeader';
import { IngestionHistoryComponent } from '@/features/customers/components/admin/IngestionHistory';
import { TriggerIngestion } from '@/features/customers/components/admin/TriggerIngestion';

export const Route = createFileRoute('/_authed/admin/customer-imports/')({
  component: CustomerAdminPage,
});

function CustomerAdminPage() {

  return (
    <ProtectedComponent
      requiredRole={UserRole.Admin}
      fallbackType={FallbackType.Page}
      fallbackTitle="Customer/License Data"
      fallbackAction="manage customer data ingestion"
    >
      <Container fluid size="xl" px="xs">
        <Stack gap="lg">
          <PageHeader
            title="Customer/License Data"
            subtitle="Manage customer data ingestion and synchronization"
            backButton={false}
          />

          <Stack gap="xl">
            <TriggerIngestion/>
            <IngestionHistoryComponent take={15}/>
          </Stack>
        </Stack>
      </Container>
    </ProtectedComponent>
  );
}